export const getLineHeight = (fontSize = 18): number => fontSize * 1.2;
